import { render } from "./About.vue?vue&type=template&id=32cea9fe"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=32cea9fe&lang=css"
script.render = render

export default script